// @flow
import { handleResponseOld } from './helpers';
import superagent from 'superagent';

export default {
    fetchHealthCheckData: () =>
        new Promise<any>((resolve, reject) => {
            const request = superagent.get('/healthcheck');
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
};
